"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const custom_filter_1 = require("components/atoms/custom-filter");
const ProductionStatisticColumnProps = [
    {
        show: true,
        field: 'ticket_no',
        title: 'Ticket No',
        width: '200',
        filter: 'text',
        filterable: true,
    },
    {
        show: true,
        field: 'pos_name',
        title: 'Pos',
        width: '100',
        filterable: true,
        filter: 'text',
    },
    {
        show: true,
        field: 'main_entrance_in',
        title: 'Entrance In',
        width: '200',
        filter: 'date',
        filterable: true,
        format: constants_1.formatGridDate.ddMMyyyyHHmm
    },
    {
        show: true,
        field: 'gate_in',
        title: 'Gate In',
        width: '200',
        filterable: false,
        format: `${constants_1.formatGridDate.ddMMyyyyHHmm}`
    },
    {
        show: true,
        field: 'queue_time',
        title: 'Queue Time',
        width: '150',
        filterCell: custom_filter_1.FilterTImePicker,
    },
    {
        show: true,
        field: 'gate_out',
        title: 'Exit Gate',
        width: '200',
        filter: 'date',
        filterable: true,
        format: `${constants_1.formatGridDate.ddMMyyyyHHmm}`
    },
    {
        show: true,
        field: 'lead_time',
        title: 'Lead Time',
        width: '150',
        filterable: true,
        filterCell: custom_filter_1.FilterTImePicker,
    },
    {
        show: true,
        field: 'contractor_dt_code',
        title: 'Contractor DT',
        width: '150',
        filterable: true,
        filter: 'text',
    },
    {
        show: true,
        field: 'dumptruck_no',
        title: 'DT No',
        width: '100',
        filterable: true,
        filter: 'text',
    },
    {
        show: true,
        field: 'capacity_volume',
        title: 'Capacity',
        width: '125',
        filterable: true,
        filter: 'numeric',
    },
    {
        show: true,
        field: 'penalty',
        title: 'Penalty',
        width: '125',
        filterable: true,
        filter: 'text',
    },
    {
        show: true,
        field: 'nett_volume',
        title: 'Nett Capacity',
        width: '125',
        filterable: true,
        filter: 'numeric',
    },
    {
        show: true,
        field: 'contractor_ex_code',
        title: 'Contractor Excavator',
        width: '150',
        filterable: true,
        filter: 'text',
    },
    {
        show: true,
        field: 'excavator_no',
        title: 'Excavator',
        width: '150',
        filterable: true,
        filter: 'text',
    },
    {
        show: true,
        field: 'pit_name',
        title: 'Pit',
        width: '150',
        filterable: true,
        filter: 'text',
    },
    {
        show: true,
        field: 'area_name',
        title: 'Area',
        width: '100',
        filterable: true,
        filter: 'text',
    },
    {
        show: true,
        field: 'seam_name',
        title: 'Seam',
        width: '100',
        filterable: true,
        filter: 'text',
    },
    {
        show: true,
        field: 'brand_name',
        title: 'Brand',
        width: '120',
        filterable: true,
        filter: 'text',
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180px',
        filter: 'text'
    }
];
exports.default = ProductionStatisticColumnProps;
